// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Stack, SxProps, Theme, Typography } from '@mui/material';
import { PropsWithChildren, ReactNode } from 'react';

interface Props {
  /**
   * The title of the card.
   */
  title: ReactNode;

  /**
   * An optional subtitle for the card.
   */
  subtitle?: string;
  variant?: 'subtitle1' | 'subtitle2';

  /**
   * Optional sx prop to pass to the main Stack component.
   */
  sx?: SxProps<Theme>;
}

/**
 * A card header component that displays a title and an optional subtitle in a
 * vertical column, with optional children to the right.
 */
export function CardHeader(props: PropsWithChildren<Props>) {
  return (
    <Stack
      useFlexGap
      spacing={1}
      padding={2}
      direction="row"
      alignItems="center"
      sx={props.sx}
    >
      <Stack marginRight="auto">
        <Typography variant={props.variant ? props.variant : 'subtitle1'}>
          {props.title}
        </Typography>
        {props.subtitle && (
          <Typography variant="body2" color="text.secondary">
            {props.subtitle}
          </Typography>
        )}
      </Stack>
      {props.children}
    </Stack>
  );
}
